<template lang="pug">
  v-card.pt-2.pb-4.px-4.mt-4(flat outlined)
    .s1.primary500--text.mt-1(style="") {{ $t('referral_program') }}
    v-row
      div.caption.c1.primary400--text.px-3 {{ $t('copy_your_code') }}  
    v-row
      v-col.py-0.px-3.grow.pr-0(style="margin-right:-2px" @click="")
        v-text-field.mt-4.p1.basic500--text(v-model="referralCode.code" solo flat background-color="basic200" height="40" color="primary" hide-details :disabled="!editMode" outlined dense style="border-top-right-radius:0px; border-bottom-right-radius:0px")
          template(v-slot:label)
            .p1.basic600--text {{ $t('referral_code') }}
      v-col.pa-0.mt-4.pl-0.pr-3.shrink
        v-btn.info500.button-AA-small.white--text(v-if="!editMode" @click="generateOrEditCode" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px; width:100px") {{ referralCode.code ? $t('change') : $t('generate') }}
        v-btn.info500.button-AA-small.white--text(v-else @click="saveCode" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px; width:100px") {{ $t('save') }}  
    v-row
      v-col.py-0.px-3.grow.pr-0(style="margin-right:-2px" @click="")
        .p1.primary500--text.mt-4 {{ $t('credit_earned') }} : {{ referralCode.code ? referralCode.credit_earned : 0 | displayPrice }}
        div.caption.c1.primary400--text {{ $t('credit_you_earned') }}
        .p1.primary500--text.mt-3 {{ $t('credit_used') }} : {{  referralCode.code ? referralCode.credit_used : 0 | displayPrice }}
        div.caption.c1.primary400--text {{ $t('credit_you_have') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ReferralInfo',
  data: () => ({
    referralCode: {},
    editMode: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    })
  },
  mounted () {
    this.fetchReferralCode()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchReferralCode () {
      this.$axios.get(`/companies/${this.company.id}/referral_code/`)
      .then(resp => {
        this.referralCode = resp.data
      }).catch(() => {})
    },
    generateOrEditCode () {
      if (this.referralCode.code) {
        this.editMode = true
      } else {
        this.$axios.post(`/companies/${this.company.id}/referral_code/`)
        .then(resp => {
          this.referralCode = resp.data
          this.showMessage(['success', `Referral code generated`])
        })
        .catch(() => {
          this.showMessage(['error', `Referral code failed to generate. Please subscribe to a plan first.`])
        })
      }
    },
    saveCode () {
      let code = this.referralCode.code.trim()
      if (/\s/.test(code)) {
        this.showMessage(['error', `Referral code must be one word`])
        return
      }

      if (!code.match(/^[0-9a-zA-Z]+$/)) {
        this.showMessage(['error', `Referral code must consists of alphabets and numbers only`])
        return
      }

      this.$axios.put(`/companies/${this.company.id}/referral_code/`, this.referralCode)
      .then(resp => {
        this.referralCode = resp.data
        this.editMode = false
        this.showMessage(['success', `Referral code updated`])
      })
      .catch(() => {
        this.showMessage(['error', `Referral code not available. Please choose different code.`])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "referral_program": "Referral Program",
    "referral_code": "Referral Code",
    "credit_earned": "Credit Earned",
    "credit_you_earned": "Credit you earned from referral program. This can be used in billing.",
    "credit_used": "Credit Used",
    "credit_you_have": "Credit you have used in billings",
    "copy_your_code": "Copy your code and share to others. Get RM 10 worth of credit when others subscribe. New subscription using your code will get 80% Off their first month subscription."
  },
  "id": {
    "referral_program": "Program referral",
    "referral_code": "Kode Referral",
    "credit_earned": "Kredit diperoleh",
    "credit_you_earned": "Kredia yang diperoleh dari referral. Bisa digunakan untuk tagihan bulanan.",
    "credit_used": "Kredit telah digunakan",
    "credit_you_have": "Kredit telah digunakan untuk pembayaran bill",
    "copy_your_code": "Salin kode kamu dan bagikan ke orang lain. Dapatkan kredit senilai RM 10 ketika orang lain berlangganan. Langganan baru menggunakan kode kamu akan mendapatkan diskon 80% untuk langganan bulan pertama mereka."
  }
}
</i18n>